import React, { useContext, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiMoreHorizontal } from "react-icons/fi";
import { AuthContext } from "../context/AuthContext";
import { logout } from "../utils/auth";
import { toast } from "react-toastify";
import Sidebar from "./Sidebar";

const Navbar = () => {
  const { usuario, setUsuario } = useContext(AuthContext);
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const puedeAdministrarPermisos = Boolean(usuario?.permisos_autorizados);
  const esAdmin = usuario?.role === "admin" || Boolean(usuario?.is_superuser);
  const puedeVerAuditoria = Boolean(usuario?.auditoria_autorizada);

  const handleLogout = async () => {
    await logout();
    setUsuario(null);
    setMobileMenuOpen(false);
    toast.info("Sesion finalizada correctamente");
    navigate("/login");
  };

  const handleNavigate = () => {
    setSidebarOpen(false);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="topbar">
        <div className="topbar__inner">
          <div className="topbar__brand-group">
            <button
              type="button"
              className="topbar__menu-btn"
              aria-label={sidebarOpen ? "Cerrar menu lateral" : "Abrir menu lateral"}
              aria-expanded={sidebarOpen}
              onClick={() => setSidebarOpen((prev) => !prev)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <Link className="app-brand" to="/" onClick={handleNavigate}>
              <img
                src="/logo-inta.png"
                alt="Logo INTA"
                className="brand-logo"
              />
              <span>INTA CIAP Córdoba</span>
            </Link>
          </div>

          <button
            type="button"
            className="topbar__actions-btn"
            aria-label={mobileMenuOpen ? "Cerrar acciones" : "Abrir acciones"}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((prev) => !prev)}
          >
            <FiMoreHorizontal />
          </button>

          <nav className="topbar__nav" aria-label="Administración y usuario">
            {puedeAdministrarPermisos && (
              <NavLink className={({ isActive }) => `topbar__link${isActive ? " topbar__link--active" : ""}`} to="/permisos" onClick={handleNavigate}>
                Permisos
              </NavLink>
            )}
            {puedeVerAuditoria && (
              <NavLink className={({ isActive }) => `topbar__link${isActive ? " topbar__link--active" : ""}`} to="/auditoria" onClick={handleNavigate}>
                Auditoría
              </NavLink>
            )}
            {esAdmin && (
              <NavLink className={({ isActive }) => `topbar__link${isActive ? " topbar__link--active" : ""}`} to="/usuarios" onClick={handleNavigate}>
                Usuarios
              </NavLink>
            )}
            {usuario ? (
              <div className="topbar__user">
                <span className="topbar__username">{usuario.username}</span>
                <button className="btn btn-link topbar__action" type="button" onClick={handleLogout}>
                  Cerrar sesión
                </button>
              </div>
            ) : (
              <NavLink className={({ isActive }) => `topbar__link${isActive ? " topbar__link--active" : ""}`} to="/login">
                Iniciar sesión
              </NavLink>
            )}
          </nav>

          <div className={`topbar__mobile-panel${mobileMenuOpen ? " topbar__mobile-panel--open" : ""}`}>
            <nav className="topbar__mobile-nav" aria-label="Acciones de usuario">
              {puedeAdministrarPermisos && (
                <NavLink className={({ isActive }) => `topbar__mobile-link${isActive ? " topbar__mobile-link--active" : ""}`} to="/permisos" onClick={handleNavigate}>
                  Permisos
                </NavLink>
              )}
              {puedeVerAuditoria && (
                <NavLink className={({ isActive }) => `topbar__mobile-link${isActive ? " topbar__mobile-link--active" : ""}`} to="/auditoria" onClick={handleNavigate}>
                  Auditoría
                </NavLink>
              )}
              {esAdmin && (
                <NavLink className={({ isActive }) => `topbar__mobile-link${isActive ? " topbar__mobile-link--active" : ""}`} to="/usuarios" onClick={handleNavigate}>
                  Usuarios
                </NavLink>
              )}
              {usuario ? (
                <>
                  <div className="topbar__mobile-user">{usuario.username}</div>
                  <button className="topbar__mobile-link topbar__mobile-link--button" type="button" onClick={handleLogout}>
                    Cerrar sesión
                  </button>
                </>
              ) : (
                <NavLink className={({ isActive }) => `topbar__mobile-link${isActive ? " topbar__mobile-link--active" : ""}`} to="/login" onClick={handleNavigate}>
                  Iniciar sesión
                </NavLink>
              )}
            </nav>
          </div>
        </div>
      </header>

      <Sidebar isOpen={sidebarOpen} onNavigate={handleNavigate} />
    </>
  );
};

export default Navbar;
